<template>
    <div :class="[
        {
            container: !message.reply_message,
            merchantMessage: message.sent_by_merchant,
        },
    ]">
        <strong v-html="header"></strong>
        <div v-html="body"></div>
        <button class="btn btn-sm paymentButton" @click="visitToPaymentLink">
            {{ action?.display_text }}
        </button>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});

const header = ref(props.message?.content?.interactive?.header?.text ?? "");
const body = ref(props.message?.content?.interactive?.body?.text ?? "");
const action = ref(
    props.message?.content?.interactive?.action?.parameters ?? {}
);

function makeBold(text) {
    const regex = /\*(.*?)\*/g;
    return text.replace(regex, "<strong>$1</strong>").replace(/\n/g, "<br />");
}

const visitToPaymentLink = () => {
    window.open(action.value.url ?? "#", "_blank");
};

onMounted(() => {
    header.value = makeBold(header.value);
    body.value = makeBold(body.value);
});
</script>

<style scoped lang="scss">
@import './styles/paymentDetails.scss'
</style>
